<!-- 关于我们 -->
<template>

    <div class="joinbox">
        <Header ></Header>
        <div class="banxin">
         <div class="title_tab">
             <p @click="isuser=true" :class="isuser?'active':'' ">关于我们</p>
             <p @click="isuser=false" :class="!isuser?'active':'' ">用户协议</p>
         </div>
         <div class="content">
             <div v-if="isuser">
                <p class="title">关于暖暖星球</p>
                    <p class="txt">暖暖星球是广州赛驷网络科技有限公司旗下的一款直播软件，是一个综合性的全民手机直播交友App。视频K歌，交友聊天，才艺表演，高颜值的都在暖暖星球，这里拒绝色情和低俗。
                    在暖暖星球，你可以通过直播、视频、文字、语音、图片来展示自己， 基于地理位置发现附近的人，同城交友，建立真实、有效、健康的社交关系。
                    3年老平台值得信赖，快进入直播间与Ta面对面互动吧，你的Ta从未如此真实，如此靠近你。
                        </p>
                </div>
             <div class="txtss" v-else>
                <p class="title">暖暖星球用户协议</p>
                    <p class="txt">
                <b>提示：请您认真阅读并充分理解本《服务协议》（下称《协议》）全部内容，特别是免除或者限制暖暖星球责任的免责条款以及对用户的权利限制条款。 </b> <br>
                请您在认真阅读并充分理解《协议》内容之后决定是否接受本《协议》。如您是未成年人（未满18周岁），须在法定监护人陪同下阅读并决定是否接受本《协议》。您接受本《协议》全部内容之后，即可注册、登录或使用本《协议》所涉相关服务。 <b>您的注册、登录、使用等行为视为对本《协议》全部内容的接受。 </b><br>
                本《协议》是您（下称“用户”）与暖暖星球公司（广州赛驷网络科技有限公司，下称“暖暖星球”）之间关于注册、登录“暖暖星球”视频直播平台以及使用“暖暖星球”视频直播平台服务所订立的协议，本《协议》约定了暖暖星球与用户之间关于“暖暖星球”服务方面的权利义务。 “用户”是指注册、登录、使用、浏览、获取本《协议》项下服务的个人或组织。<br> 
               <b>本《协议》内容由暖暖星球随时更新，用户可在本网站查阅最新版协议条款。更新后的协议条款一旦公布即代替原来的协议条款。协议条款更新后，如您不同意接受，您不应继续使用暖暖星球提供的服务。 </b>
                        </p>
                   <h5>一、使用规则</h5>
                          <p class="txt">                    
                      1、用户充分理解并同意：暖暖星球仅为用户提供信息存储、分享平台服务，用户必须为自己注册帐号下发生一切行为负责，包括因您所传送至暖暖星球平台的任何内容、信息等所导致的不利后果，该等不利后果包括但不限于赔偿、罚款、司法/仲裁程序费用、律师费、合理支出、给暖暖星球造成的损害等。用户应对暖暖星球平台上其他注册用户（包括主播）发布的内容自行加以判断，并承担因使用该内容而给自己、他人及社会造成的法律责任，包括但不限于因对内容的准确性、真实性、完整性或实用性等的依赖而产生的风险。 
                       <br>
                      2、用户在使用暖暖星球服务中发布的任何内容、信息等并不反映或代表暖暖星球的观点、立场或政策，暖暖星球对此不承担任何责任。 
                      <br>
                      3、用户充分理解并同意：暖暖星球是一个基于用户关系网的点对点信息服务平台，用户须对在暖暖星球上的注册信息的真实性、合法性、有效性承担全部责任，用户不得冒充他人或利用他人的名义传播任何信息，不得恶意使用注册帐号导致其他用户误认。否则，暖暖星球有权立即停止提供服务，注销用户的暖暖星球帐号，用户应自行承担由此而产生的一切法律责任。 
                     <br>
                      4、暖暖星球对用户上传的所有信息的真实性、合法性、无害性、有效性等不负任何单独或连带之保证责任，用户因其所传播的信息而引发的相关法律责任由用户自行承担。 
                     <br>
                      5、用户充分理解并同意：因业务发展需要、突发情势等，暖暖星球可能会临时变更，暂停、限制或者终止暖暖星球部分或全部服务，暖暖星球将努力但不保证能做到事先通知。用户知悉并愿意承担该类风险。 
                      <br>
                      6、用户充分理解并同意：暖暖星球提供的服务中可能包括广告。用户同意在使用服务过程中显示暖暖星球和第三方供应商、合作伙伴提供的广告。同时，暖暖星球有权在直播间内添加网站logo（或名称）和时间的水印标志。暖暖星球将尽力但不保证不影响您的直播体验。 
                       <br>
                      7、用户不得利用暖暖星球或暖暖星球视频直播平台服务制作、上载、传播包含如下任何内容的信息：  <br>
                      (1)反对宪法所确定的基本原则的；  <br>
                      (2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>
                      (3)损害国家荣誉和利益的；  <br>
                      (4)煽动民族仇恨、民族歧视，破坏民族团结的；  <br>
                      (5)破坏国家宗教政策，宣扬邪教和封建迷信的； <br>
                      (6)散布谣言，扰乱社会秩序，破坏社会稳定的； <br>
                      (7)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； <br>
                      (8)侮辱或者诽谤他人，侵害他人合法权益的； <br>
                      (9)含有法律、行政法规禁止的其他内容的信息。  <br>
                      8、根据合理判断，暖暖星球可以对违反法律法规、本《协议》约定，侵犯、妨害、威胁他人权利的内容，或者假冒他人名义发布的内容，依法采取停止传输、下线等措施，并有权依合理判断对违反本条款的用户采取适当的法律行动，包括但不限于：从暖暖星球服务平台中保全具有违法性、侵权性、不当性等内容、限制或禁止用户使用暖暖星球全部或部分服务、注销用户帐户以及依据法律法规保存有关信息并向有关部门报告等。
                      <br>
                      9、用户权利及义务： <br>
                      <b>  (1)暖暖星球帐号的所有权归暖暖星球所有，用户完成申请注册手续后，获得暖暖星球帐号的使用权，该使用权仅属于初始申请注册人，禁止用户赠与、借用、租用、转让或售卖暖暖星球帐号。如果使用者并非帐号初始申请注册人，暖暖星球有权在未经通知的情况下冻结、回收该帐号而无需向该帐号使用人承担法律责任，由此导致的包括并不限于用户通讯中断、用户资料和虚拟道具等清空等损失由用户自行承担。若帐号的归属出现争议的，赛驷公司在收到相关方的投诉后，有权暂时冻结该争议帐号；争议各方在举证期（7个工作日）内提供证据证明帐号归属，赛驷公司依据各方提供的证据判断归属后，解冻争议帐号。 
                     </b>
                      <br>
                      (2)用户可以更改、删除在暖暖星球帐号或平台上的个人资料、注册信息及传送内容等（但用户不可自行注销暖暖星球帐号）。用户在更改、删除有关信息的同时也可能会造成储存在系统中的文字、图片、视频等丢失，暖暖星球对用户自主操作导致内容丢失不承担责任。 <b>请注意，手机号或微信号一经与暖暖星球帐号绑定，无法解除绑定。  </b>
                      <br>
                      (3)用户有责任妥善保管注册帐号信息及帐号密码的安全，用户需要对注册帐号下的行为承担法律责任。由于帐号、密码等信息外借、泄露或者被他人盗用而引起的法律责任，由注册用户自行承担。用户同意在任何情况下不使用其他用户的帐号。 
                      <br>
                       <b>
                      (4)用户应遵守本协议的各项条款，正确、适当地使用本服务，不得扰乱平台秩序，包括但不限于扰乱平台金融秩序（如出售钻石、暖币等）。如用户违反本协议或其他平台规则的任何条款，暖暖星球有权依据协议终止/暂停对违约用户暖暖星球帐号提供全部或部分服务。若帐号任何功能被终止/中止的，无法参加任何官方活动。若账号被永久封禁的，账号内的钻石和暖币将被全部清空，不予取现。 需要特别注意的是，涉嫌使用不合理手段充值（包括但不限于非法使用信用卡套现）的帐号，暖暖星球依其合理判断将暂时或永久封停该帐号。同时，暖暖星球保留在任何时候收回暖暖星球帐号、用户名的权利。 
                      </b>
                      <br>
                      (5)用户保证注册暖暖星球帐号时提供的信息真实、完整。因信息非法、不真实、不准确等所产生的法律责任由用户承担。用户注册信息发生变更的，应及时更新注册资料，满足及时、详尽、真实、准确的要求。
                      <br>
                      (6)用户可以在使用暖暖星球服务过程中购买钻石、暖币等虚拟道具增值服务。除法律规定的情形外，用户购买虚拟道具之后，暖暖星球不提供退、换或兑现成人民币或其他任何货币的服务。 
                      <br>
                      (7)如您的账户同时符合以下条件：1）连续12个月未登录暖暖星球App；2）不存在未到期的有效付费业务。暖暖星球有权予以进行注销、回收、替换或采取删除该账户在暖暖星球平台数据库中的任何记录（包括但不限于注册信息、虚拟礼物信息等）等清理措施，以免造成资源浪费。在对此类账户进行清理前，将以包括但不限于弹窗、站内消息、客户端推送信息等方式通知您。清理后您的账户将不能再登录，相应服务同时终止。 
                      <br>
                      (8)用户同意授予暖暖星球无偿使用通过暖暖星球平台发布的或用户使用暖暖星球服务过程中形成的信息、内容等，暖暖星球可以通过包括改编、汇编、复制、发行、网络传播在内的一切方式进行使用。如果用户不同意暖暖星球使用相关内容，应事先通过书面方式告知暖暖星球。 
                      <br>
                      (9)用户在使用暖暖星球提供的服务过程中，若发现涉政、涉枪、涉毒、涉暴、赌博、涉黄的内容，可以向暖暖星球工作人员举报、投诉。暖暖星球在收到举报、投诉后，将派专员及时处理。 
                       <br>
                      (10)您不得利用暖暖星球进行任何形式的洗钱活动。暖暖星球将严密监控此类行为，并有权对多个定向账户中异常的、数额较大的虚拟资产流转进行调查，并有权配合主管机关的调查提交您的身份资料、有关账户的交易记录等信息。                       
                        </p>
                          <h5>二、隐私保护</h5>
                            <p class="txt">
                          用户知悉并同意：个人隐私信息是指能够对用户进行个人辨识或涉及个人通信的信息，包括用户真实姓名、身份证号、手机号码、银行账户、IP地址等。非个人隐私信息是指用户对本服务的操作状态以及使用习惯等一些明确且客观反映在暖暖星球服务器端的基本记录信息和其他一切个人隐私信息范围外的普通信息，以及用户同意公开的上述隐私信息。 
                          暖暖星球尊重用户个人隐私信息的私有性，暖暖星球将会采取合理的措施保护用户的个人隐私信息，除法律或有法律赋予权限的政府部门要求或用户同意等原因外，暖暖星球未经用户同意不向除合作单位以外的第三方公开、透露用户个人隐私信息。 
                          用户在注册时选择同意，或用户与暖暖星球及合作单位之间就用户个人隐私信息公开或使用另有约定的除外，用户应自行承担因此可能产生的任何风险，暖暖星球对此不承担责任。 
                          为了运营和改善暖暖星球的技术和服务，便于暖暖星球向用户提供更好的用户体验和提高暖暖星球的服务质量，暖暖星球将可能会自行收集使用或向第三方提供用户的非个人隐私信息，具体请仔细阅读《隐私声明》。
                          </p>
                          <h5>三、暖暖星球商业标识信息</h5>
                          <p class="txt">
                          暖暖星球服务中所涉及的暖暖星球图形、文字或其组成，以及其他暖暖星球标志及产品、服务名称，均为暖暖星球之商业标识（以下简称“暖暖星球标识”）。未经暖暖星球事先书面同意，用户不得将暖暖星球标识以任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理暖暖星球标识的行为。用户由于非法使用暖暖星球标识给暖暖星球或他人造成损失的，由用户承担相关法律责任。
                          </p>
                    
                          <h5>四、知识产权</h5>
                       <p class="txt">
                          1、平台的服务包括暖暖星球运营的网站、网页应用、软件以及内含的文字、图片、视频、音频等元素，暖暖星球对其服务标志、标识以及上述任何元素享有全部知识产权。 
                           <br>
                          2、用户在平台提供直播服务期间产生的任何成果（包括但不限于直播视频、音频，以下统称“主播成果”）的知识产权由用户享有。 <b>您同意许可暖暖星球在全世界范围内永久性地、不可撤销地、独家地使用和可再许可及（或）转授权任意第三方使用主播成果，包括但不限于复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及《著作权法》规定的由著作权人享有的其他著作财产权利，暖暖星球无须对此额外向用户支付任何费用。 
                          <br>
                          3、任何第三方未经暖暖星球同意，不得将用户在平台上的主播成果、所发表言论等进行复制、修改、编辑、转让、使用、通过信息网络传播或作其他用途，包括但不限于通过截取视频信号、抓取录播音频／视频、编辑视频/音频/文字和其他形式的内容等方式。否则，暖暖星球有权就任何主体侵权而以暖暖星球自己的名义单独或委托第三方机构提起诉讼或开展其他法律行动，并获得全部赔偿。
                            </b>
                          </p>
                         
                          <h5>五、法律责任及免责</h5>
                            <p class="txt">
                          <b>
                          1、用户违反本《协议》或相关服务条款的约定，导致第三方向暖暖星球及其合作公司、关联公司提出索赔等要求的，用户同意承担全部法律责任，包括但不限于赔偿金、罚金、和解费、诉讼仲裁费、合理的律师费支出等，并同意赔偿因此给暖暖星球造成的损害。 
                           </b>
                          <br>
                          2、用户因第三方如电信部门的通讯线路故障、技术问题、网络、电脑故障、系统不稳定性及其他各种不可抗力原因而遭受的一切损失，暖暖星球及其合作单位不承担责任。 
                          <br>
                          3、因技术故障等不可抗事件影响到服务的正常运行的，暖暖星球及其合作单位承诺在第一时间内与相关单位配合，及时处理进行修复，但用户因此而遭受的一切损失，暖暖星球及其合作单位不承担责任。 
                           <br>
                          4、用户理解：本服务同其他互联网服务一样，用户在使用服务过程中会受到网络服务质量、社会环境、用户操作错误等诸多因素的影响，可能会受到各种问题的侵扰，比如他人利用用户的资料，进行现实生活中的骚扰。用户下载安装的其它软件或访问的其他网站中含有“特洛伊木马”等病毒，威胁到用户的计算机信息和数据的安全，继而影响本服务的正常使用等等。用户应加强对信息安全及使用者资料的保护意识，以免遭受损失和骚扰，因使用暖暖星球服务的风险由用户自行承担。 
                          <br>5、用户理解：本服务涉及Internet服务，可能会受到各个环节不稳定因素的影响，本服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险。因前述情形导致用户不能发送、接受、阅读信息、或接发错信息，暖暖星球不承担任何责任。 
                          <br>6、用户理解：使用本服务过程中存在可能面对来自他人的包括但不限于威胁性的、诽谤性的、令人反感的或其他非法的内容或行为和/或侵犯他人权利（包括但不限于知识产权）的匿名或冒名的信息的风险，用户须承担以上风险。暖暖星球和其合作公司对视频直播平台服务不作任何明确或暗示的担保，包括但不限于有关信息真实性、适商性、适于某一特定用途、所有权和非侵权性的内容，对因此导致任何因用户不正当或非法使用暖暖星球平台服务产生的直接、间接、偶然、特殊及后续等侵犯第三人之合法权利的法律责任，暖暖星球不承担任何责任。 
                          <br>7、暖暖星球提供的信息内容包括但不限于：文字、软件、声音、相片、录像、图表，在广告中的全部内容，以及暖暖星球为用户提供的商业信息。上述所有信息均受著作权法、商标法和其它知识产权法以及物权法、其他相关中国法律的保护。用户只能在暖暖星球和合作方明确授权的情况下才能使用这些内容，不得擅自实施包括但不限于复制、修改、编纂上述内容、或创造与该内容有关的衍生产品的行为。 
                          <br>8、在任何情况下，暖暖星球对任何由于用户使用暖暖星球视频直播平台而导致的间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括但不限于因用户使用暖暖星球平台服务而遭受的各项损失均不承担责任（即使暖暖星球已被告知该等损失发生的可能性）。尽管本协议中可能含有特殊约定，暖暖星球对用户承担的全部责任，无论因何原因或何种行为导致，均不超过用户在使用暖暖星球服务期内支付给暖暖星球的费用(如有)。
                          </p>
                          <h5>六、其他条款</h5>                    
                       <p class="txt">
                            1、特别提示：请用户注册、使用本《协议》服务之前，认真阅读本《协议》中限制、免除暖暖星球义务责任和加重用户义务责任的条款，并请自主考虑风险。如果您是未成年人（未满18周岁），应在法定监护人的陪同下阅读本《协议》，并在充分理解本《协议》各项条款的情况下注册使用。同时，未成年人的任何充值行为将被暖暖星球视为已取得法定监护人的同意。 
                         <br>2、本《协议》条款部分或全部无效，不影响其它条款的效力。 
                         <br>3、本《协议》解释、效力及纠纷的解决，适用中华人民共和国法律。 
                         <br>4、用户和暖暖星球之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。 
                         <br>5、暖暖星球保留本《协议》修改权利。    
                          </p>
                </div>

             </div>
    
        </div>
         <Footer></Footer>
    </div>  
</template>
<script>
import Header from "../../components/header"
import Footer from "../../components/footer"
export default {
     components: {
            Header,Footer
        },
    data(){
        return{
          isuser:true
        }
    },
     created(){

    },
    methods:{

    },
}
</script>
<style lang="less" scoped>
  .joinbox{
       background:rgba(250,250,250,1);
  }
  .title_tab{
      display: flex;  height:.4rem ; align-items: center;
      p{
      margin-right: .2rem; font-size:0.11rem;font-weight:600;color:rgba(153,153,153,1);   
      cursor:pointer;
      }
      .active{
        color:rgba(51,51,51,1);  position: relative;
      }
      .active::after{
          content: "";
          position: absolute;
          bottom: -.06rem;
          left: 50%; transform: translateX(-50%);
         width:0.2rem;
        height:0.02rem;
        background:rgba(255,32,94,1);
        border-radius:0.01rem; 
      }
  }
  .content{
     border-radius:.1rem;background:rgba(255,255,255,1);
       padding: .18rem;height: 3.11rem;
       .title{
           width: 100%; text-align: center;font-size:0.12rem;
           color:rgba(51,51,51,1);
       }
       .txtss{
         height: 100%; overflow: auto; 
         h5{
        margin: .1rem auto 0 auto; width: 80%;font-size:0.1rem;
         }
         .txt{
           color: #666;
         }
         b{
           color: #000; font-weight: 400;
         }
       }
       .txt{
         margin: .05rem auto 0 auto; width: 80%; font-size:0.09rem;   color:rgba(51,51,51,1);line-height:0.16rem;
       }
     
  }
</style>


// WEBPACK FOOTER //
// src/page/webpage/aboutus.vue